/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useTenantContext } from '../tenant-context/index.tsx';

type AccountId = string;

/**
 * Returns the current user's account ID, or null for anonymous users.
 *
 * @agent-skills: tenant-context
 */
export const useAccountId = (): AccountId | null => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.atlassianAccountId) || null;
};
